var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrobackward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.28501 0.291769L0.285014 5.29177C0.193973 5.38687 0.122608 5.49902 0.0750135 5.62177C-0.0250045 5.86523 -0.0250045 6.13831 0.0750135 6.38177C0.122608 6.50452 0.193973 6.61666 0.285014 6.71177L5.28501 11.7118C5.37825 11.805 5.48894 11.879 5.61076 11.9294C5.73259 11.9799 5.86315 12.0059 5.99501 12.0059C6.26132 12.0059 6.51671 11.9001 6.70501 11.7118C6.89332 11.5235 6.9991 11.2681 6.9991 11.0018C6.9991 10.7355 6.89332 10.4801 6.70501 10.2918L3.40501 7.00177L10.995 7.00177C11.2602 7.00177 11.5146 6.89641 11.7021 6.70887C11.8897 6.52134 11.995 6.26698 11.995 6.00177C11.995 5.73655 11.8897 5.4822 11.7021 5.29466C11.5146 5.10712 11.2602 5.00177 10.995 5.00177L3.40501 5.00177L6.70501 1.71177C6.79874 1.6188 6.87314 1.5082 6.9239 1.38634C6.97467 1.26449 7.00081 1.13378 7.00081 1.00177C7.00081 0.869757 6.97467 0.739051 6.9239 0.617191C6.87314 0.495332 6.79874 0.384732 6.70501 0.291769C6.61205 0.198041 6.50145 0.123645 6.37959 0.072876C6.25773 0.0221071 6.12703 -0.00403023 5.99501 -0.00403023C5.863 -0.00403023 5.7323 0.0221071 5.61044 0.072876C5.48858 0.123645 5.37798 0.198041 5.28501 0.291769Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrobackward);
export default __webpack_public_path__ + "static/media/arro backward.d2318f421d4f5c796363e380f5446ab6.svg";
export { ForwardRef as ReactComponent };